import { Route, Routes } from "react-router-dom";
import { useSetPageTitle } from "../../context/PageTitleContext";
import ClassDetail from "./ClassDetail";
import Classes from "./classes";

const ClassesRoutes = () => {
  useSetPageTitle("Le mie classi", "Seleziona una classe per vedere i corsi");

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
      <Routes>
        <Route path=":id" element={<ClassDetail />} />
        <Route index element={<Classes />} />
      </Routes>
    </div>
  );
};

export default ClassesRoutes;
